// The generated API client, made once per console and handed down by context (spec/08 §1.1: the
// only HTTP client a console uses). Tests hand in one built on a fake `fetch`.

import { createApiClient, type ApiClient, type FetchLike } from '@clavian/api-client';
import { createContext, useContext, type ReactNode } from 'react';

import { announceWrites } from './writes';

export interface ConsoleApiOptions {
  /** Defaults to `VITE_CLAVIAN_API_URL`, then the console's own origin. */
  readonly baseUrl?: string;
  readonly fetch?: FetchLike;
}

export function createConsoleApi(options: ConsoleApiOptions = {}): ApiClient {
  return createApiClient({
    baseUrl: options.baseUrl ?? import.meta.env.VITE_CLAVIAN_API_URL ?? '',
    // The web consoles authenticate with better-auth's session cookie, never a bearer token
    // (spec/08 §2.2).
    credentials: 'include',
    fetch: announceWrites(options.fetch ?? ((input, init) => globalThis.fetch(input, init))),
  });
}

const ApiContext = createContext<ApiClient | null>(null);

export function ApiProvider({ api, children }: { readonly api: ApiClient; readonly children: ReactNode }) {
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiClient {
  const api = useContext(ApiContext);
  if (api === null) throw new Error('useApi() needs an <ApiProvider> above it.');
  return api;
}
